import { LegacyTextMessage } from 'components/LegacyTextMessage';
import { Markdown } from 'components/Markdown';
import { PlainTextMessage } from 'routes/Chat/Messages/PlainTextMessage';
import { TEXT_FORMAT } from 'routes/Chat/Messages/constants';
import { FormattedMessagesType, TTextFormat } from 'routes/Chat/Messages/types';

type TFormatttedTextMessageProps = {
  format?: TTextFormat;
  raw: string | null;
  message: FormattedMessagesType;
};

/**
 * Given a `format`, parse the text and render the components.
 * Returns `null` if no format is found.
 * @returns
 */
const FormattedTextMessage = ({ raw, format, message }: TFormatttedTextMessageProps) => {
  if (!format) return null;
  if (!raw) return null;

  const formatters: { [k: string]: () => JSX.Element } = {
    [TEXT_FORMAT.MARKDOWN]: () => {
      return (
        <PlainTextMessage
          contentWidth='100%'
          text={<Markdown>{raw.replaceAll('\\n', '\n')}</Markdown>}
        />
      );
    },
    [TEXT_FORMAT.PLAIN_TEXT]: () => <PlainTextMessage text={raw} />,
    [TEXT_FORMAT.LEGACY]: () => {
      // Needed to support message body extensions; otherwise message.text is null
      message.text = raw;
      return <LegacyTextMessage message={message} />;
    },
  };

  return (formatters[format] && formatters[format]()) ?? null;
};

export default FormattedTextMessage;
